import { Control, FieldValues, Path, useController } from 'react-hook-form';
import Select from './Select/Select';
import { ISelectOption } from '../../types/ISelectOption';
import { useFieldId, useFieldRequired } from './FieldWrapper/FieldWrapper';

type FormSelectProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  options: ISelectOption[];
  placeholder?: string;
  disabled?: boolean;
};

export function FormSelect<T extends FieldValues>({
  name,
  control,
  options,
  placeholder,
  disabled,
}: FormSelectProps<T>) {
  const { field, fieldState } = useController({ name, control });
  // Set by the enclosing `FieldWrapper`, whose `<label>` points at it.
  const fieldId = useFieldId();
  const isRequired = useFieldRequired();

  return (
    <Select
      id={fieldId}
      required={isRequired}
      options={options}
      value={field.value ?? null}
      onChange={(val) => field.onChange(val)}
      placeholder={placeholder}
      disabled={disabled}
      error={fieldState.error?.message ?? null}
    />
  );
}
